import { render, staticRenderFns } from "./ZodiacForm.vue?vue&type=template&id=0b5f4320&"
import script from "./ZodiacForm.vue?vue&type=script&lang=js&"
export * from "./ZodiacForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports